var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdrHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29441",
    "data-name": "Group 29441",
    transform: "translate(-8 -662.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 662.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-adr",
    transform: "translate(24 668.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50553",
    "data-name": "Path 50553",
    d: "M0,0H15.112V15.112H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 10.686)",
    fill: "#ff6f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50554",
    "data-name": "Path 50554",
    d: "M13.193,22.586,3.8,13.193,13.193,3.8l9.393,9.393ZM5.148,13.193l8.044,8.044,8.044-8.044L13.193,5.148Z",
    transform: "translate(-2.474 -2.507)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50555",
    "data-name": "Path 50555",
    d: "M14.511,22.72H13.255l-.232.93H12L13.441,19h.883l1.441,4.65H14.79Zm-1.069-.79h.883l-.465-1.674Zm2.743,1.72V19h1.209a1.75,1.75,0,0,1,1.3.511,2.208,2.208,0,0,1,.511,1.395v.744a2.071,2.071,0,0,1-.465,1.441,1.629,1.629,0,0,1-1.348.511H16.185Zm.93-3.859v3.069h.279a.843.843,0,0,0,.651-.232,1.311,1.311,0,0,0,.186-.837V21a1.638,1.638,0,0,0-.186-.93.691.691,0,0,0-.6-.279ZM22.183,21.7a1.613,1.613,0,0,0,.279-2.325A1.487,1.487,0,0,0,21.393,19H19.9v4.65h.93V21.976H21.3l.651,1.674h1.023V23.6Zm-.418-.7a.453.453,0,0,1-.418.186h-.511V19.79h.511q.558,0,.558.7A.835.835,0,0,1,21.765,21Z",
    transform: "translate(-6.861 -10.639)",
    fill: "#000001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdrHighlighted);
export default __webpack_public_path__ + "static/media/ADRHighlighted.4235f6d84be9b87ab6be32c7af3a7c40.svg";
export { ForwardRef as ReactComponent };